import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { Payment } from '@models';
import { Store } from '@ngrx/store';
import { fetchPayments, selectPayments, selectPaymentsFetchedAt } from '@state';
import { PaymentUtils } from '@utils';

@Component({
  selector: 'app-payments',
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    CommonModule,
    MatCardModule,
  ],
  templateUrl: './payments.page.html',
  styleUrl: './payments.page.scss',
})
export class PaymentsPage {
  public paymentsDisabled = false;

  $payments = this.store.select(selectPayments);
  $paymentsFetchedAt = this.store.select(selectPaymentsFetchedAt);

  public columns: string[] = [
    'netCashPaymentId',
    'batchName',
    'total',
    'status',
  ];

  constructor(private store: Store, private router: Router) {}

  public ngOnInit(): void {
    this.store.dispatch(fetchPayments());
  }

  public navToPaymentDetails(paymentId: string): void {
    this.router.navigate(['/payments', paymentId]);
  }

  public filterByDateRange() {
    this.store.dispatch(fetchPayments());
  }

  public isPaid(payment: Payment): boolean {
    return PaymentUtils.isPaid(payment.status);
  }

  public getStatusText(payment: Payment): string {
    return PaymentUtils.getStatusText(payment.status);
  }
}
